import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import $ from 'jquery';
import 'jquery-ui/themes/base/all.css';
import 'jquery-ui/ui/widgets/datepicker';
import Select from "react-select";

import Sidebar from "../../component/Sidebar";
import Topbar from "../../component/Topbar";
import { FiSave, FiTrash2, FiFileText, FiUser, FiPackage, FiArrowLeft, FiPlus, FiCalendar, FiSettings, FiAlignLeft, FiDollarSign } from "react-icons/fi";

import { baseurl } from "../../baseurl";
import axios from "axios";
import Swal from "sweetalert2";

/* ─── CSS ─── */
const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Sora:wght@400;600;700;800&family=DM+Sans:wght@400;500;600&display=swap');

:root {
  --eq-teal:      #0a5556;
  --eq-teal-mid:  #0c7172;
  --eq-teal-lite: #14b8a6;
  --eq-gold:      #FFD166;
  --eq-bg:        #eef6f6;
  --eq-white:     #ffffff;
  --eq-border:    rgba(10,85,86,0.10);
  --eq-text:      #0f2a2a;
  --eq-muted:     #5a8080;
  --eq-danger:    #ef4444;
  --eq-success:   #10b981;
  --eq-warning:   #f59e0b;
}

@keyframes eq__fadeUp  { from{opacity:0;transform:translateY(16px)} to{opacity:1;transform:translateY(0)} }
@keyframes eq__shimmer { 0%{background-position:-600px 0} 100%{background-position:600px 0} }
@keyframes eq__spin    { to{transform:rotate(360deg)} }

.eq__wrap {
  font-family:'DM Sans',sans-serif;
  padding:22px 22px 40px;
  background:var(--eq-bg);
  min-height:100vh;
  animation:eq__fadeUp 0.4s ease both;
}

.eq__hd { display:flex; align-items:flex-start; justify-content:space-between; gap:16px; margin-bottom:24px; flex-wrap:wrap; }
.eq__hd-left { display:flex; align-items:center; gap:14px; }
.eq__hd-icon {
  width:48px; height:48px; border-radius:14px; flex-shrink:0;
  background:linear-gradient(135deg,var(--eq-teal),var(--eq-teal-lite));
  display:flex; align-items:center; justify-content:center;
  font-size:20px; color:#fff;
  box-shadow:0 6px 18px rgba(10,85,86,0.26);
}
.eq__hd-title { font-family:'Sora',sans-serif; font-size:20px; font-weight:800; color:var(--eq-text); letter-spacing:-0.03em; margin:0 0 3px; }
.eq__hd-sub   { font-size:12.5px; color:var(--eq-muted); margin:0; }

.eq__back-btn {
  display:inline-flex; align-items:center; gap:7px;
  padding:9px 16px; border-radius:11px;
  font-size:13px; font-family:'Sora',sans-serif; font-weight:700;
  color:var(--eq-teal); background:rgba(10,85,86,0.07);
  border:1.5px solid rgba(10,85,86,0.16); cursor:pointer;
  transition:all 0.16s; text-decoration:none;
}
.eq__back-btn:hover { background:rgba(10,85,86,0.12); color:var(--eq-teal); text-decoration:none; }

.eq__card {
  background:var(--eq-white); border-radius:20px;
  border:1px solid var(--eq-border);
  box-shadow:0 2px 20px rgba(10,85,86,0.07),0 8px 40px rgba(0,0,0,0.03);
  margin-bottom:20px; overflow:hidden; position:relative;
  animation:eq__fadeUp 0.45s ease both;
}
.eq__card::before {
  content:''; position:absolute; top:0; left:0; right:0; height:3px;
  background:linear-gradient(90deg,var(--eq-teal) 0%,var(--eq-teal-lite) 55%,var(--eq-gold) 100%);
}
.eq__sec-hd {
  display:flex; align-items:center; gap:10px;
  padding:18px 22px 14px; border-bottom:1px solid var(--eq-border);
}
.eq__sec-icon {
  width:34px; height:34px; border-radius:10px; flex-shrink:0;
  background:linear-gradient(135deg,var(--eq-teal),var(--eq-teal-lite));
  display:flex; align-items:center; justify-content:center;
  font-size:15px; color:#fff;
  box-shadow:0 4px 10px rgba(10,85,86,0.22);
}
.eq__sec-title { font-family:'Sora',sans-serif; font-size:13.5px; font-weight:700; color:var(--eq-text); }
.eq__sec-sub   { font-size:11.5px; color:var(--eq-muted); margin-left:auto; }
.eq__body      { padding:20px 22px; }

.eq__lbl {
  display:flex; align-items:center; gap:6px;
  font-size:10.5px; font-weight:700; color:var(--eq-text);
  margin-bottom:6px; letter-spacing:0.06em; text-transform:uppercase;
}
.eq__lbl-dot { width:5px; height:5px; border-radius:50%; background:var(--eq-teal); flex-shrink:0; }
.eq__opt-badge {
  font-size:9px; color:#9ababa; background:rgba(10,85,86,0.06);
  border:1px solid #c8e4e4; border-radius:50px;
  padding:1px 7px; margin-left:4px; text-transform:none; letter-spacing:0;
}

.eq__input, .eq__select, .eq__textarea {
  width:100%; padding:10px 13px;
  font-size:13px; font-family:'DM Sans',sans-serif; color:var(--eq-text);
  background:#f3fafa; border:1.5px solid #c8e4e4; border-radius:11px;
  outline:none; box-sizing:border-box;
  transition:border-color 0.18s, box-shadow 0.18s, background 0.18s;
}
.eq__input:focus,.eq__select:focus,.eq__textarea:focus {
  border-color:var(--eq-teal); background:#fff;
  box-shadow:0 0 0 4px rgba(10,85,86,0.09);
}
.eq__input::placeholder,.eq__textarea::placeholder { color:#9ababa; }
.eq__input[readonly] { background:rgba(10,85,86,0.04); color:var(--eq-muted); }
.eq__select {
  appearance:none;
  background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%235a8080' stroke-width='2.5'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E");
  background-repeat:no-repeat; background-position:right 12px center;
  padding-right:32px;
}
.eq__textarea { resize:vertical; min-height:90px; }
.eq__field-wrap { position:relative; }
.eq__field-icon { position:absolute; left:11px; top:50%; transform:translateY(-50%); color:#7aadad; font-size:14px; pointer-events:none; }
.eq__input--icon { padding-left:33px; }

.eq__grid2 { display:grid; grid-template-columns:1fr 1fr; gap:14px; }
.eq__grid3 { display:grid; grid-template-columns:1fr 1fr 1fr; gap:14px; }
.eq__grid4 { display:grid; grid-template-columns:1fr 1fr 1fr 1fr; gap:14px; }

.eq__num-chip {
  display:inline-flex; align-items:center; gap:8px;
  background:rgba(10,85,86,0.07); border:1px solid rgba(10,85,86,0.15);
  border-radius:10px; padding:9px 14px;
  font-family:'Sora',sans-serif; font-size:13px; font-weight:700;
  color:var(--eq-teal); width:100%;
}
.eq__num-chip-label { font-size:9px; text-transform:uppercase; letter-spacing:0.1em; color:var(--eq-muted); font-weight:600; }

.eq__toggle-group { display:flex; gap:4px; }
.eq__toggle-btn {
  flex:1; padding:9px 10px; border-radius:10px;
  font-size:12px; font-family:'Sora',sans-serif; font-weight:700;
  border:1.5px solid rgba(10,85,86,0.18); background:var(--eq-bg);
  color:var(--eq-muted); cursor:pointer; text-align:center;
  transition:all 0.18s;
}
.eq__toggle-btn:hover { border-color:var(--eq-teal); color:var(--eq-teal); background:rgba(10,85,86,0.05); }
.eq__toggle-btn--active {
  background:linear-gradient(135deg,var(--eq-teal),var(--eq-teal-lite)) !important;
  border-color:transparent !important; color:#fff !important;
  box-shadow:0 4px 12px rgba(10,85,86,0.26);
}

.eq__status-select {
  width:100%; padding:9px 13px;
  font-size:13px; font-family:'Sora',sans-serif; font-weight:700;
  border:1.5px solid #c8e4e4; border-radius:11px;
  background:#f3fafa; color:var(--eq-teal);
  appearance:none;
  background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%235a8080' stroke-width='2.5'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E");
  background-repeat:no-repeat; background-position:right 12px center; padding-right:32px;
  outline:none; box-sizing:border-box; cursor:pointer;
  transition:border-color 0.18s, box-shadow 0.18s;
}
.eq__status-select:focus { border-color:var(--eq-teal); background:#fff; box-shadow:0 0 0 4px rgba(10,85,86,0.09); }
.eq__status-select[data-status="Pending"]  { background-color:rgba(245,158,11,0.07);  color:#b45309; border-color:rgba(245,158,11,0.30); }
.eq__status-select[data-status="Accepted"] { background-color:rgba(59,130,246,0.07);  color:#2563eb; border-color:rgba(59,130,246,0.25); }
.eq__status-select[data-status="Declined"] { background-color:rgba(239,68,68,0.07);   color:#dc2626; border-color:rgba(239,68,68,0.25); }
.eq__status-select[data-status="Invoiced"] { background-color:rgba(16,185,129,0.07);  color:#047857; border-color:rgba(16,185,129,0.25); }

.eq__gst-badge {
  display:inline-flex; align-items:center; gap:5px;
  font-size:10.5px; font-weight:700; font-family:'Sora',sans-serif;
  border-radius:50px; padding:3px 10px;
}
.eq__gst-badge--igst { background:rgba(59,130,246,0.09); color:#2563eb; border:1px solid rgba(59,130,246,0.18); }
.eq__gst-badge--cgst { background:rgba(10,85,86,0.08);   color:var(--eq-teal); border:1px solid rgba(10,85,86,0.16); }

.eq__billing-grid { display:grid; grid-template-columns:1fr 1px 1fr; }
.eq__billing-sep  { background:var(--eq-border); margin:0 20px; }
.eq__billing-col  { padding:20px 22px; }
.eq__billing-hd   { display:flex; align-items:center; gap:8px; margin-bottom:14px; }
.eq__billing-hd-icon {
  width:28px; height:28px; border-radius:8px; flex-shrink:0;
  display:flex; align-items:center; justify-content:center; font-size:13px;
}
.eq__billing-hd-icon--seller   { background:rgba(10,85,86,0.10); color:var(--eq-teal); }
.eq__billing-hd-icon--customer { background:rgba(20,184,166,0.12); color:var(--eq-teal-lite); }
.eq__billing-hd-title { font-family:'Sora',sans-serif; font-size:12.5px; font-weight:700; color:var(--eq-text); }
.eq__billing-hd-sub   { font-size:11px; color:var(--eq-muted); margin-left:auto; }

.eq__table-wrap { overflow-x:auto; }
.eq__table { width:100%; border-collapse:collapse; min-width:580px; }
.eq__table thead th {
  font-family:'Sora',sans-serif; font-size:10px; font-weight:700;
  letter-spacing:0.09em; text-transform:uppercase; color:var(--eq-teal);
  background:rgba(10,85,86,0.04); padding:10px 12px;
  white-space:nowrap; border-bottom:1px solid var(--eq-border);
}
.eq__table tbody tr { border-bottom:1px solid rgba(10,85,86,0.05); }
.eq__table tbody tr:last-child { border-bottom:none; }
.eq__table tbody tr:hover { background:rgba(10,85,86,0.02); }
.eq__table tbody td { padding:8px 12px; vertical-align:middle; }
.eq__ti, .eq__ts {
  width:100%; padding:7px 10px;
  font-size:12.5px; font-family:'DM Sans',sans-serif; color:var(--eq-text);
  background:#f3fafa; border:1.5px solid #c8e4e4; border-radius:9px;
  outline:none; box-sizing:border-box;
  transition:border-color 0.16s, box-shadow 0.16s;
}
.eq__ti:focus,.eq__ts:focus { border-color:var(--eq-teal); background:#fff; box-shadow:0 0 0 3px rgba(10,85,86,0.09); }
.eq__ts {
  appearance:none;
  background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 24 24' fill='none' stroke='%235a8080' stroke-width='2.5'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E");
  background-repeat:no-repeat; background-position:right 8px center; padding-right:24px;
}
.eq__amount-cell { font-family:'Sora',sans-serif; font-size:13px; font-weight:700; color:var(--eq-teal); text-align:right; }
.eq__del-btn {
  width:30px; height:30px; border-radius:8px; border:none;
  background:transparent; cursor:pointer; color:var(--eq-muted);
  display:flex; align-items:center; justify-content:center; font-size:14px;
  transition:background 0.15s, color 0.15s;
}
.eq__del-btn:hover { background:rgba(239,68,68,0.09); color:var(--eq-danger); }
.eq__add-item-btn {
  display:inline-flex; align-items:center; gap:7px;
  padding:8px 16px; border-radius:10px;
  font-size:12.5px; font-family:'Sora',sans-serif; font-weight:700;
  color:var(--eq-teal); background:rgba(10,85,86,0.07);
  border:1.5px dashed rgba(10,85,86,0.28); cursor:pointer;
  transition:background 0.16s; margin:12px 22px 16px;
}
.eq__add-item-btn:hover { background:rgba(10,85,86,0.12); border-color:var(--eq-teal); }

/* ── PRODUCT CATALOG TOGGLE BAR ── */
.eq__product-toggle-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 22px;
  background: rgba(10,85,86,0.03);
  border-bottom: 1px solid var(--eq-border);
}
.eq__product-toggle-left {
  display: flex;
  align-items: center;
  gap: 9px;
}
.eq__product-toggle-label {
  font-family: 'Sora', sans-serif;
  font-size: 12px;
  font-weight: 700;
  color: var(--eq-teal);
  letter-spacing: .03em;
}
.eq__product-toggle-sub {
  font-size: 10.5px;
  color: var(--eq-muted);
  margin-top: 1px;
}
/* iOS pill switch */
.eq__pill-switch {
  position: relative;
  width: 40px;
  height: 22px;
  flex-shrink: 0;
}
.eq__pill-switch input { opacity:0; width:0; height:0; position:absolute; }
.eq__pill-slider {
  position: absolute;
  cursor: pointer;
  inset: 0;
  background: #c8e4e4;
  border-radius: 50px;
  transition: background .25s;
}
.eq__pill-slider::before {
  content: '';
  position: absolute;
  height: 16px; width: 16px;
  left: 3px; top: 3px;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 1px 4px rgba(0,0,0,.18);
  transition: transform .25s;
}
.eq__pill-switch input:checked + .eq__pill-slider { background: linear-gradient(135deg, var(--eq-teal), var(--eq-teal-lite)); }
.eq__pill-switch input:checked + .eq__pill-slider::before { transform: translateX(18px); }

/* react-select overrides */
.eq-rs__control {
  background: #f3fafa !important;
  border: 1.5px solid #c8e4e4 !important;
  border-radius: 9px !important;
  min-height: 34px !important;
  box-shadow: none !important;
  font-family: 'DM Sans', sans-serif !important;
  font-size: 12.5px !important;
  transition: border-color .18s, box-shadow .18s !important;
}
.eq-rs__control--is-focused {
  border-color: var(--eq-teal) !important;
  background: #fff !important;
  box-shadow: 0 0 0 3px rgba(10,85,86,.09) !important;
}
.eq-rs__placeholder { color: #9ababa !important; font-size: 12.5px !important; }
.eq-rs__single-value { color: var(--eq-text) !important; font-size: 12.5px !important; }
.eq-rs__input-container { color: var(--eq-text) !important; font-size: 12.5px !important; }
.eq-rs__menu {
  border-radius: 12px !important;
  border: 1.5px solid #c8e4e4 !important;
  box-shadow: 0 8px 28px rgba(10,85,86,.14) !important;
  overflow: hidden !important;
  font-family: 'DM Sans', sans-serif !important;
  z-index: 9999 !important;
}
.eq-rs__option { font-size: 12.5px !important; padding: 9px 14px !important; cursor: pointer !important; }
.eq-rs__option--is-focused { background: rgba(10,85,86,.06) !important; color: var(--eq-text) !important; }
.eq-rs__option--is-selected { background: linear-gradient(135deg, var(--eq-teal), var(--eq-teal-lite)) !important; color: #fff !important; }
.eq-rs__indicator-separator { background-color: #c8e4e4 !important; }
.eq-rs__dropdown-indicator { color: var(--eq-teal) !important; padding: 0 8px !important; }
.eq-rs__clear-indicator { color: var(--eq-muted) !important; }
.eq-rs__value-container { padding: 2px 10px !important; }

/* product option renderer */
.eq-opt__badge {
  display: inline-block;
  padding: 1px 7px;
  border-radius: 50px;
  font-size: 9.5px;
  font-weight: 700;
  font-family: 'Sora', sans-serif;
  margin-left: 6px;
  vertical-align: middle;
}
.eq-opt__badge--service { background: rgba(20,184,166,.15); color: #0c7172; }
.eq-opt__badge--product { background: rgba(255,209,102,.22); color: #8a6000; }
.eq-opt__meta { font-size: 10.5px; color: var(--eq-muted); margin-top: 1px; }
.eq-opt__row { display: flex; align-items: center; justify-content: space-between; }
.eq-opt__rate { font-family: 'Sora', sans-serif; font-weight: 700; font-size: 11px; color: var(--eq-teal); }

.eq__bottom { display:grid; grid-template-columns:1fr 1fr; gap:20px; }

.eq__summary {
  background:var(--eq-white); border-radius:20px;
  border:1px solid var(--eq-border);
  box-shadow:0 2px 20px rgba(10,85,86,0.07);
  overflow:hidden; position:relative;
}
.eq__summary::before {
  content:''; position:absolute; top:0; left:0; right:0; height:3px;
  background:linear-gradient(90deg,var(--eq-teal),var(--eq-teal-lite),var(--eq-gold));
}
.eq__summary-hd { display:flex; align-items:center; gap:10px; padding:16px 20px 12px; border-bottom:1px solid var(--eq-border); }
.eq__summary-body { padding:16px 20px; display:flex; flex-direction:column; gap:8px; }
.eq__sum-row { display:flex; align-items:center; justify-content:space-between; font-size:13px; }
.eq__sum-lbl { color:var(--eq-muted); }
.eq__sum-val { font-weight:600; color:var(--eq-text); }
.eq__sum-sep { height:1px; background:var(--eq-border); margin:3px 0; }
.eq__sum-total {
  display:flex; align-items:center; justify-content:space-between;
  padding:14px 20px; background:linear-gradient(135deg,var(--eq-teal),var(--eq-teal-mid));
  border-radius:0 0 20px 20px;
}
.eq__sum-total-lbl { font-family:'Sora',sans-serif; font-size:12px; font-weight:700; color:rgba(255,255,255,0.75); text-transform:uppercase; letter-spacing:0.06em; }
.eq__sum-total-val { font-family:'Sora',sans-serif; font-size:22px; font-weight:800; color:#fff; letter-spacing:-0.02em; }

.eq__submit-btn {
  width:100%; padding:14px;
  font-size:15px; font-family:'Sora',sans-serif; font-weight:700;
  color:#fff; letter-spacing:0.04em;
  background:linear-gradient(135deg,var(--eq-teal),var(--eq-teal-mid),var(--eq-teal-lite));
  background-size:200% auto;
  border:none; border-radius:13px; cursor:pointer;
  box-shadow:0 6px 24px rgba(10,85,86,0.34);
  transition:background-position 0.4s, transform 0.14s;
  display:flex; align-items:center; justify-content:center; gap:8px;
  position:relative; overflow:hidden; margin-top:14px;
}
.eq__submit-btn::after {
  content:''; position:absolute; inset:0;
  background:linear-gradient(90deg,transparent,rgba(255,255,255,0.12),transparent);
  background-size:400px 100%; opacity:0; transition:opacity 0.3s;
}
.eq__submit-btn:hover { background-position:right center; transform:translateY(-1px); }
.eq__submit-btn:hover::after { opacity:1; animation:eq__shimmer 1.1s linear infinite; }

.eq__loading {
  min-height:80vh; display:flex; flex-direction:column;
  align-items:center; justify-content:center; gap:16px;
  font-family:'Sora',sans-serif;
}
.eq__loading-spinner {
  width:44px; height:44px; border-radius:50%;
  border:3px solid rgba(10,85,86,0.15);
  border-top-color:var(--eq-teal);
  animation:eq__spin 0.8s linear infinite;
}
.eq__loading-text { font-size:14px; font-weight:600; color:var(--eq-muted); }

@media(max-width:900px){
  .eq__billing-grid { grid-template-columns:1fr; }
  .eq__billing-sep  { display:none; }
  .eq__bottom       { grid-template-columns:1fr; }
  .eq__grid4        { grid-template-columns:1fr 1fr; }
}
@media(max-width:600px){
  .eq__grid2,.eq__grid3,.eq__grid4 { grid-template-columns:1fr; }
}
`;

/* ─── Helpers ─── */
const GST_SLABS = [0, 5, 12, 18, 28];

const splitGST = (totalTax, gstType) => {
  if (gstType === "IGST") return { IGST: totalTax, CGST: 0, SGST: 0 };
  return { IGST: 0, CGST: totalTax / 2, SGST: totalTax / 2 };
};

const getItemAmountDisplay = (item) => {
  const amount = item.qty * item.rate;
  return `₹ ${amount.toFixed(2)}`;
};

/* ── Custom Option renderer for React Select ── */
const ProductOption = ({ innerRef, innerProps, data, isSelected }) => (
  <div
    ref={innerRef}
    {...innerProps}
    style={{
      padding: "9px 14px",
      cursor: "pointer",
      background: isSelected ? "linear-gradient(135deg, #0a5556, #14b8a6)" : "transparent",
      color: isSelected ? "#fff" : "#0f2a2a",
    }}
  >
    <div className="eq-opt__row">
      <span style={{ fontWeight: 600, fontSize: 12.5 }}>
        {data.label}
        <span
          className={`eq-opt__badge ${data.type === "Service" ? "eq-opt__badge--service" : "eq-opt__badge--product"}`}
          style={isSelected ? { background: "rgba(255,255,255,.22)", color: "#fff" } : {}}
        >
          {data.type}
        </span>
      </span>
      <span className="eq-opt__rate" style={isSelected ? { color: "rgba(255,255,255,.85)" } : {}}>
        ₹{data.rate}
      </span>
    </div>
    <div className="eq-opt__meta" style={isSelected ? { color: "rgba(255,255,255,.65)" } : {}}>
      HSN/SAC: {data.hsn || "—"} · GST {data.tax}%
    </div>
  </div>
);

/* ─── Component ─── */
function EditQuotation() {
  const { encodedId } = useParams();
  const navigate = useNavigate();
  const token = localStorage.getItem("auth_token");

  const [loading, setLoading] = useState(true);

  // ── Product Catalog State ──
  const [productOptions, setProductOptions] = useState([]);
  const [useProductDropdown, setUseProductDropdown] = useState(false);

  const [quotation, setQuotation] = useState({
    quotationNumber: "",
    quotationDate: "",
    validityDate: "",
    status: "Pending",
    customer: { name: "", email: "", phone: "", address: "", gstin: "", state: "" },
    seller:   { name: "", gstin: "", state: "", phone: "" },
    items: [],
    discount: 0,
    additionalCharges: 0,
    gstInclusive: false,
    notes: "",
  });

  const [applyGSTItemWise, setApplyGSTItemWise]       = useState(true);
  const [quotationGSTPercent, setQuotationGSTPercent] = useState(18);

  /* ── Fetch Quotation (unchanged) ── */
  useEffect(() => {
    const fetchQuotationData = async () => {
      try {
        const id = atob(encodedId);
        const res = await axios.get(`${baseurl}getQuotationById/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (res.data.success) {
          const d = res.data.data;
          setQuotation({ ...d.quotation_data, id: d.id, quotationNumber: d.quotation_number, status: d.status });
          if (d.quotation_data.quotationGSTPercent) {
            setQuotationGSTPercent(d.quotation_data.quotationGSTPercent);
            setApplyGSTItemWise(false);
          }
        }
      } catch (error) {
        console.error("Fetch Error:", error);
        Swal.fire("Error", "Could not load quotation data", "error");
      } finally {
        setLoading(false);
      }
    };
    if (encodedId) fetchQuotationData();
  }, [encodedId, token]);

  /* ── Fetch Product Catalog ── */
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await axios.get(`${baseurl}getAllProducts`, {
          headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        });
        if (res.data.success && res.data.data) {
          const options = res.data.data.map((p) => ({
            value: p.id,
            label: p.product_data?.name || `Product #${p.id}`,
            description: p.product_data?.name || "",
            hsn: p.product_data?.hsn_sac || "",
            rate: p.product_data?.rate ?? 0,
            tax: p.product_data?.tax_percent ?? 18,
            type: p.type || "Product",
            unit: p.product_data?.unit || "",
          }));
          setProductOptions(options);
        }
      } catch (err) {
        console.error("Error fetching products:", err);
      }
    };
    fetchProducts();
  }, []);

  /* ── jQuery datepicker (unchanged) ── */
  useEffect(() => {
    if (loading) return;
    const $qDate = $('#quotationDateInput');
    const $vDate = $('#validityDateInput');
    const handleDateSelect = (dateText, inst) => {
      const fieldName = inst.id === 'quotationDateInput' ? 'quotationDate' : 'validityDate';
      updateQuotationMeta(fieldName, dateText);
    };
    $qDate.datepicker({ dateFormat: "yy-mm-dd", onSelect: handleDateSelect });
    $vDate.datepicker({ dateFormat: "yy-mm-dd", onSelect: handleDateSelect });
    return () => { $qDate.datepicker('destroy'); $vDate.datepicker('destroy'); };
  }, [loading]);

  useEffect(() => {
    if (!loading) {
      $('#quotationDateInput').datepicker('setDate', quotation.quotationDate);
      $('#validityDateInput').datepicker('setDate', quotation.validityDate);
    }
  }, [quotation.quotationDate, quotation.validityDate, loading]);

  /* ── Updaters (unchanged) ── */
  const updateQuotationMeta = (f, v) => setQuotation(prev => ({ ...prev, [f]: v }));
  const updateCustomer      = (f, v) => setQuotation(prev => ({ ...prev, customer: { ...prev.customer, [f]: v } }));
  const updateSeller        = (f, v) => setQuotation(prev => ({ ...prev, seller:   { ...prev.seller,   [f]: v } }));
  const updateItem = (index, field, value) => {
    const items = [...quotation.items];
    items[index][field] = value;
    setQuotation({ ...quotation, items });
  };
  const addItem    = () => setQuotation(prev => ({ ...prev, items: [...prev.items, { description: "", hsn: "", qty: 1, rate: 0, tax: 0 }] }));
  const removeItem = (index) => setQuotation(prev => ({ ...prev, items: prev.items.filter((_, i) => i !== index) }));

  /* ── Handle product selection from dropdown ── */
  const handleProductSelect = (index, selectedOption) => {
    const items = [...quotation.items];
    if (!selectedOption) {
      items[index] = { ...items[index], description: "", hsn: "", rate: 0, tax: 18 };
    } else {
      items[index] = {
        ...items[index],
        description: selectedOption.description,
        hsn: selectedOption.hsn,
        rate: selectedOption.rate,
        tax: selectedOption.tax,
        // qty intentionally preserved
      };
    }
    setQuotation({ ...quotation, items });
  };

  const getSelectedProductOption = (item) => {
    if (!item.description) return null;
    return productOptions.find(
      (o) => o.description === item.description && o.rate === item.rate
    ) || null;
  };

  /* ── Calculations ── */
  const { items, discount, additionalCharges, gstInclusive, customer, seller } = quotation;
  const itemSubtotal   = items.reduce((acc, item) => acc + item.qty * item.rate, 0);
  const discountAmount = (itemSubtotal * (parseFloat(discount) || 0)) / 100;
  const taxableAmount  = itemSubtotal - discountAmount + Number(additionalCharges);

  const calculateTotalTax = () =>
    items.reduce((acc, item) => {
      const itemAmount     = item.qty * item.rate;
      const itemDiscounted = itemAmount - (itemAmount * (parseFloat(discount) || 0) / 100);
      const taxRate        = applyGSTItemWise ? item.tax : quotationGSTPercent;
      return acc + (gstInclusive
        ? (itemDiscounted * taxRate) / (100 + taxRate)
        : (itemDiscounted * taxRate) / 100);
    }, 0);

  const totalTax = calculateTotalTax();

  // ── IGST fix: only inter-state if BOTH states are filled AND differ ──
  const isInterState =
    !!(customer.state?.trim()) &&
    !!(seller.state?.trim()) &&
    customer.state.trim().toLowerCase() !== seller.state.trim().toLowerCase();

  const gstType = isInterState ? "IGST" : "CGST/SGST";
  const { IGST, CGST, SGST } = splitGST(totalTax, gstType);
  const grandTotal = gstInclusive ? taxableAmount : taxableAmount + totalTax;

  /* ── Submit (unchanged) ── */
  const handleSubmit = async (e) => {
    e.preventDefault();
    const id = atob(encodedId);
    const dataToSend = {
      ...quotation, grandTotal, totalTax, taxableAmount,
      quotationGSTPercent: applyGSTItemWise ? null : quotationGSTPercent,
    };
    try {
      const response = await axios.post(`${baseurl}updateQuotation/${id}`, dataToSend, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.data.success) {
        Swal.fire("Success", "Quotation updated successfully!", "success");
        navigate("/estimates");
      }
    } catch (err) {
      Swal.fire("Error", "Update failed", "error");
    }
  };

  /* ── Loading screen ── */
  if (loading) return (
    <>
      <style>{CSS}</style>
      <Topbar /><Sidebar />
      <main className="main-wrapper">
        <div className="eq__loading">
          <div className="eq__loading-spinner" />
          <div className="eq__loading-text">Loading Quotation…</div>
        </div>
      </main>
    </>
  );

  /* ═══ RENDER ═══ */
  return (
    <>
      <style>{CSS}</style>
      <Topbar />
      <Sidebar />
      <main className="main-wrapper">
        <form onSubmit={handleSubmit}>
          <div className="eq__wrap">

            {/* ── Header ── */}
            <div className="eq__hd">
              <div className="eq__hd-left">
                <div className="eq__hd-icon"><FiFileText /></div>
                <div>
                  <div className="eq__hd-title">Edit GST Quotation</div>
                  <div className="eq__hd-sub">Update and manage price quotations for customers</div>
                </div>
              </div>
              <button type="button" className="eq__back-btn" onClick={() => navigate("/estimates")}>
                <FiArrowLeft size={14} /> Back to Quotations
              </button>
            </div>

            {/* ══ SECTION 1 — Quotation Details ══ */}
            <div className="eq__card">
              <div className="eq__sec-hd">
                <div className="eq__sec-icon"><FiFileText size={15} /></div>
                <div className="eq__sec-title">Quotation Details</div>
              </div>
              <div className="eq__body">
                <div className="eq__grid4">
                  <div>
                    <div className="eq__lbl"><div className="eq__lbl-dot" />Quotation Number</div>
                    <div className="eq__num-chip">
                      <span className="eq__num-chip-label">QT#</span>
                      <span>{quotation.quotationNumber || "—"}</span>
                    </div>
                  </div>
                  <div>
                    <div className="eq__lbl"><div className="eq__lbl-dot" />Quotation Date</div>
                    <div className="eq__field-wrap">
                      <FiCalendar className="eq__field-icon" />
                      <input type="text" id="quotationDateInput" className="eq__input eq__input--icon"
                        value={quotation.quotationDate} readOnly />
                    </div>
                  </div>
                  <div>
                    <div className="eq__lbl"><div className="eq__lbl-dot" />Valid Until</div>
                    <div className="eq__field-wrap">
                      <FiCalendar className="eq__field-icon" />
                      <input type="text" id="validityDateInput" className="eq__input eq__input--icon"
                        value={quotation.validityDate} readOnly />
                    </div>
                  </div>
                  <div>
                    <div className="eq__lbl"><div className="eq__lbl-dot" />Status</div>
                    <select
                      className="eq__status-select"
                      data-status={quotation.status}
                      value={quotation.status}
                      onChange={(e) => updateQuotationMeta("status", e.target.value)}
                    >
                      <option value="Pending">Pending</option>
                      <option value="Accepted">Accepted</option>
                      <option value="Declined">Declined</option>
                      <option value="Invoiced">Invoiced</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            {/* ══ SECTION 2 — GST Settings ══ */}
            <div className="eq__card">
              <div className="eq__sec-hd">
                <div className="eq__sec-icon"><FiSettings size={15} /></div>
                <div className="eq__sec-title">GST &amp; Tax Settings</div>
                <span className="eq__sec-sub">
                  <span className={`eq__gst-badge ${isInterState ? "eq__gst-badge--igst" : "eq__gst-badge--cgst"}`}>
                    {isInterState ? "IGST (Inter-state)" : "CGST + SGST (Intra-state)"}
                  </span>
                </span>
              </div>
              <div className="eq__body">
                <div className="eq__grid3">
                  <div>
                    <div className="eq__lbl"><div className="eq__lbl-dot" />GST Mode</div>
                    <div className="eq__toggle-group">
                      <button type="button" className={`eq__toggle-btn ${!quotation.gstInclusive ? "eq__toggle-btn--active" : ""}`}
                        onClick={() => setQuotation({ ...quotation, gstInclusive: false })}>Exclusive</button>
                      <button type="button" className={`eq__toggle-btn ${quotation.gstInclusive ? "eq__toggle-btn--active" : ""}`}
                        onClick={() => setQuotation({ ...quotation, gstInclusive: true })}>Inclusive</button>
                    </div>
                  </div>
                  <div>
                    <div className="eq__lbl"><div className="eq__lbl-dot" />Apply Tax By</div>
                    <div className="eq__toggle-group">
                      <button type="button" className={`eq__toggle-btn ${applyGSTItemWise ? "eq__toggle-btn--active" : ""}`}
                        onClick={() => setApplyGSTItemWise(true)}>Item-wise</button>
                      <button type="button" className={`eq__toggle-btn ${!applyGSTItemWise ? "eq__toggle-btn--active" : ""}`}
                        onClick={() => setApplyGSTItemWise(false)}>Quote-wise</button>
                    </div>
                  </div>
                  {!applyGSTItemWise && (
                    <div>
                      <div className="eq__lbl"><div className="eq__lbl-dot" />Quotation GST %</div>
                      <select className="eq__select" value={quotationGSTPercent}
                        onChange={(e) => setQuotationGSTPercent(parseFloat(e.target.value))}>
                        {GST_SLABS.map((g) => <option key={g} value={g}>{g}%</option>)}
                      </select>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* ══ SECTION 3 — Billing ══ */}
            <div className="eq__card">
              <div className="eq__sec-hd">
                <div className="eq__sec-icon"><FiUser size={15} /></div>
                <div className="eq__sec-title">Billing Details</div>
              </div>
              <div className="eq__billing-grid">
                {/* Seller */}
                <div className="eq__billing-col">
                  <div className="eq__billing-hd">
                    <div className="eq__billing-hd-icon eq__billing-hd-icon--seller"><FiUser /></div>
                    <span className="eq__billing-hd-title">Seller Details</span>
                  </div>
                  <div className="eq__grid2" style={{ marginBottom:12 }}>
                    <div>
                      <div className="eq__lbl"><div className="eq__lbl-dot" />Name</div>
                      <input type="text" className="eq__input" value={seller.name} onChange={(e) => updateSeller("name", e.target.value)} />
                    </div>
                    <div>
                      <div className="eq__lbl"><div className="eq__lbl-dot" />Phone</div>
                      <input type="text" className="eq__input" value={seller.phone} onChange={(e) => updateSeller("phone", e.target.value)} />
                    </div>
                  </div>
                  <div className="eq__grid2">
                    <div>
                      <div className="eq__lbl"><div className="eq__lbl-dot" />GSTIN <span className="eq__opt-badge">Optional</span></div>
                      <input type="text" className="eq__input" value={seller.gstin} onChange={(e) => updateSeller("gstin", e.target.value)} />
                    </div>
                    <div>
                      <div className="eq__lbl"><div className="eq__lbl-dot" />State</div>
                      <input type="text" className="eq__input" value={seller.state} onChange={(e) => updateSeller("state", e.target.value)} />
                    </div>
                  </div>
                </div>

                <div className="eq__billing-sep" />

                {/* Customer */}
                <div className="eq__billing-col">
                  <div className="eq__billing-hd">
                    <div className="eq__billing-hd-icon eq__billing-hd-icon--customer"><FiUser /></div>
                    <span className="eq__billing-hd-title">Customer Details</span>
                  </div>
                  <div className="eq__grid2" style={{ marginBottom:12 }}>
                    <div>
                      <div className="eq__lbl"><div className="eq__lbl-dot" />Name</div>
                      <input type="text" className="eq__input" value={customer.name} onChange={(e) => updateCustomer("name", e.target.value)} />
                    </div>
                    <div>
                      <div className="eq__lbl"><div className="eq__lbl-dot" />Phone</div>
                      <input type="text" className="eq__input" value={customer.phone} onChange={(e) => updateCustomer("phone", e.target.value)} />
                    </div>
                  </div>
                  <div className="eq__grid2" style={{ marginBottom:12 }}>
                    <div>
                      <div className="eq__lbl"><div className="eq__lbl-dot" />GSTIN <span className="eq__opt-badge">Optional</span></div>
                      <input type="text" className="eq__input" value={customer.gstin} onChange={(e) => updateCustomer("gstin", e.target.value)} />
                    </div>
                    <div>
                      <div className="eq__lbl"><div className="eq__lbl-dot" />State</div>
                      <input type="text" className="eq__input" value={customer.state} onChange={(e) => updateCustomer("state", e.target.value)} />
                    </div>
                  </div>
                  <div>
                    <div className="eq__lbl"><div className="eq__lbl-dot" />Address</div>
                    <textarea className="eq__textarea" style={{ minHeight:58 }} value={customer.address}
                      onChange={(e) => updateCustomer("address", e.target.value)} rows="2" />
                  </div>
                </div>
              </div>
            </div>

            {/* ══ SECTION 4 — Items ══ */}
            <div className="eq__card">
              <div className="eq__sec-hd">
                <div className="eq__sec-icon"><FiPackage size={15} /></div>
                <div className="eq__sec-title">Quotation Items</div>
                <span className="eq__sec-sub">{items.length} item{items.length !== 1 ? "s" : ""}</span>
              </div>

              {/* ── Product/Service Catalog Toggle Bar ── */}
              <div className="eq__product-toggle-bar">
                <div className="eq__product-toggle-left">
                  <FiPackage size={14} style={{ color: "var(--eq-teal)" }} />
                  <div>
                    <div className="eq__product-toggle-label">
                      Select from Product / Service Catalog
                    </div>
                    <div className="eq__product-toggle-sub">
                      {useProductDropdown
                        ? `${productOptions.length} items available — search by name`
                        : "Enable to pick items from your saved catalog"}
                    </div>
                  </div>
                </div>
                <label className="eq__pill-switch">
                  <input
                    type="checkbox"
                    checked={useProductDropdown}
                    onChange={(e) => setUseProductDropdown(e.target.checked)}
                  />
                  <span className="eq__pill-slider" />
                </label>
              </div>

              <div className="eq__table-wrap">
                <table className="eq__table">
                  <thead>
                    <tr>
                      {useProductDropdown && <th style={{ width:"18%" }}>Product / Service</th>}
                      <th style={{ width: useProductDropdown ? "20%" : "34%" }}>Description</th>
                      <th style={{ width:"10%" }}>HSN / SAC</th>
                      <th style={{ width:"8%" }}>Qty</th>
                      <th style={{ width:"13%" }}>Rate ({gstInclusive ? "Incl." : "Excl."} Tax)</th>
                      {applyGSTItemWise && <th style={{ width:"10%" }}>Tax %</th>}
                      <th style={{ width:"13%", textAlign:"right" }}>Amount</th>
                      <th style={{ width:"7%", textAlign:"center" }}>Del</th>
                    </tr>
                  </thead>
                  <tbody>
                    {items.map((item, index) => (
                      <tr key={index}>

                        {/* ── Product Dropdown (only when toggle ON) ── */}
                        {useProductDropdown && (
                          <td style={{ minWidth: 170 }}>
                            <Select
                              classNamePrefix="eq-rs"
                              options={productOptions}
                              value={getSelectedProductOption(item)}
                              onChange={(opt) => handleProductSelect(index, opt)}
                              placeholder="Search…"
                              isClearable
                              components={{ Option: ProductOption }}
                              menuPortalTarget={document.body}
                              styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                control: (base) => ({ ...base, minHeight: 34 }),
                              }}
                            />
                          </td>
                        )}

                        <td>
                          <input type="text" className="eq__ti" placeholder="Item description…"
                            value={item.description} onChange={(e) => updateItem(index, "description", e.target.value)} />
                        </td>
                        <td>
                          <input type="text" className="eq__ti" placeholder="HSN"
                            value={item.hsn} onChange={(e) => updateItem(index, "hsn", e.target.value)} />
                        </td>
                        <td>
                          <input type="number" className="eq__ti" style={{ textAlign:"center" }}
                            value={item.qty} onChange={(e) => updateItem(index, "qty", parseFloat(e.target.value) || 0)} />
                        </td>
                        <td>
                          <input type="number" className="eq__ti"
                            value={item.rate} onChange={(e) => updateItem(index, "rate", parseFloat(e.target.value) || 0)} />
                        </td>
                        {applyGSTItemWise && (
                          <td>
                            <select className="eq__ts" value={item.tax}
                              onChange={(e) => updateItem(index, "tax", parseFloat(e.target.value))}>
                              {GST_SLABS.map((g) => <option key={g} value={g}>{g}%</option>)}
                            </select>
                          </td>
                        )}
                        <td><span className="eq__amount-cell">{getItemAmountDisplay(item)}</span></td>
                        <td style={{ textAlign:"center" }}>
                          <button type="button" className="eq__del-btn" style={{ margin:"0 auto" }} onClick={() => removeItem(index)}>
                            <FiTrash2 size={13} />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <button type="button" className="eq__add-item-btn" onClick={addItem}>
                <FiPlus size={13} /> Add Item
              </button>
            </div>

            {/* ══ BOTTOM — Notes + Summary ══ */}
            <div className="eq__bottom">

              {/* Notes card */}
              <div className="eq__card" style={{ marginBottom:0 }}>
                <div className="eq__sec-hd">
                  <div className="eq__sec-icon"><FiAlignLeft size={15} /></div>
                  <div className="eq__sec-title">Notes &amp; Terms</div>
                </div>
                <div className="eq__body">
                  <div>
                    <div className="eq__lbl"><div className="eq__lbl-dot" />Quotation Notes</div>
                    <textarea className="eq__textarea" rows="5"
                      placeholder="Payment Terms, Warranty, Validity…"
                      value={quotation.notes}
                      onChange={(e) => updateQuotationMeta("notes", e.target.value)} />
                  </div>
                  <div className="eq__grid2" style={{ marginTop:14 }}>
                    <div>
                      <div className="eq__lbl"><div className="eq__lbl-dot" />Discount %</div>
                      <input type="number" className="eq__input" min="0" max="100"
                        value={quotation.discount}
                        onChange={(e) => updateQuotationMeta("discount", e.target.value)} />
                    </div>
                    <div>
                      <div className="eq__lbl"><div className="eq__lbl-dot" />Additional Charges (₹)</div>
                      <input type="number" className="eq__input"
                        value={quotation.additionalCharges}
                        onChange={(e) => updateQuotationMeta("additionalCharges", e.target.value)} />
                    </div>
                  </div>
                </div>
              </div>

              {/* Summary */}
              <div className="eq__summary">
                <div className="eq__summary-hd">
                  <div className="eq__sec-icon"><FiDollarSign size={15} /></div>
                  <span className="eq__sec-title">Quotation Summary</span>
                </div>
                <div className="eq__summary-body">
                  <div className="eq__sum-row">
                    <span className="eq__sum-lbl">Subtotal</span>
                    <span className="eq__sum-val">₹ {itemSubtotal.toFixed(2)}</span>
                  </div>
                  <div className="eq__sum-row">
                    <span className="eq__sum-lbl">Discount ({quotation.discount || 0}%)</span>
                    <span className="eq__sum-val" style={{ color:"#ef4444" }}>− ₹ {discountAmount.toFixed(2)}</span>
                  </div>
                  {Number(quotation.additionalCharges) > 0 && (
                    <div className="eq__sum-row">
                      <span className="eq__sum-lbl">Additional Charges</span>
                      <span className="eq__sum-val">+ ₹ {Number(quotation.additionalCharges).toFixed(2)}</span>
                    </div>
                  )}
                  <div className="eq__sum-sep" />
                  <div className="eq__sum-row">
                    <span className="eq__sum-lbl">Taxable Amount</span>
                    <span className="eq__sum-val">₹ {taxableAmount.toFixed(2)}</span>
                  </div>
                  {gstType === "IGST" ? (
                    <div className="eq__sum-row">
                      <span className="eq__sum-lbl">IGST</span>
                      <span className="eq__sum-val">+ ₹ {IGST.toFixed(2)}</span>
                    </div>
                  ) : (
                    <>
                      <div className="eq__sum-row">
                        <span className="eq__sum-lbl">CGST</span>
                        <span className="eq__sum-val">+ ₹ {CGST.toFixed(2)}</span>
                      </div>
                      <div className="eq__sum-row">
                        <span className="eq__sum-lbl">SGST</span>
                        <span className="eq__sum-val">+ ₹ {SGST.toFixed(2)}</span>
                      </div>
                    </>
                  )}
                </div>
                <div className="eq__sum-total">
                  <span className="eq__sum-total-lbl">Grand Total</span>
                  <span className="eq__sum-total-val">₹ {grandTotal.toFixed(2)}</span>
                </div>
                <div style={{ padding:"0 20px 20px" }}>
                  <button type="submit" className="eq__submit-btn">
                    <FiSave size={16} /> Update Quotation
                  </button>
                </div>
              </div>

            </div>

          </div>
        </form>
      </main>
    </>
  );
}

export default EditQuotation;
